var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M22.765 11.565C22.765 17.409 14 25.2 14 25.2s-8.766-7.791-8.766-13.635a8.765 8.765 0 0 1 17.53 0ZM14 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z","clipRule":"evenodd"}));
}

Marker.defaultProps = {"viewBox":"0 0 28 28","fill":"none"};

module.exports = Marker;

Marker.default = Marker;
